'use strict'

module.exports = normalize

function normalize(value) {
  return value.toLowerCase().replace(/\b[:-]\b/g, '')
}



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/normalize.js
// module id = 430
// module chunks = 35783957827783 241767136424496